import { Campaign } from "@/types/types";

/** One CRM column of the table — a campaign's own field, or the merge of same-named fields across campaigns. */
export interface UnionField {
  name: string;
  type: string;
  description: string;
}

/**
 * The CRM columns for a set of campaigns, merged by field NAME (the org-wide
 * Global CRM table). One campaign → its fields in their own order, exactly
 * what the campaign table shows. Several → first appearance keeps the slot;
 * when campaigns disagree on the type the most common one wins (it decides
 * the filter editor and the sort), and the first non-empty description is
 * the header tooltip.
 */
export function unionCampaignFields(campaigns: Campaign[]): UnionField[] {
  const seen = new Map<
    string,
    { types: Map<string, number>; description: string }
  >();
  for (const campaign of campaigns) {
    for (const field of campaign.fields ?? []) {
      if (!field?.name) continue;
      const entry = seen.get(field.name) ?? {
        types: new Map<string, number>(),
        description: "",
      };
      const type = field.type || "string";
      entry.types.set(type, (entry.types.get(type) ?? 0) + 1);
      if (!entry.description && field.description) {
        entry.description = field.description;
      }
      seen.set(field.name, entry);
    }
  }
  return Array.from(seen, ([name, entry]) => {
    let type = "string";
    let best = -1;
    for (const [candidate, count] of entry.types) {
      if (count > best) {
        best = count;
        type = candidate;
      }
    }
    return { name, type, description: entry.description };
  });
}
